const conceptScrollImg = (() => {

  const pageConceptroom = (document.getElementById("pageConceptroom") != null);
  if (pageConceptroom) {

    const secSecIntro = document.getElementById('jsSecIntro');
    let modelInner = secSecIntro.querySelector('.js-model-inner');
    let imgArea = secSecIntro.querySelector('.js-img-area');
    let mainImg = secSecIntro.querySelector('.js-main-img');
    let mainCover = secSecIntro.querySelector('.js-main-cover');
    let jsSecSlide = document.getElementById('jsSecSlide');
    let body = document.querySelector('body');


    // ---------disignAreaのズーム----------
    gsap.to(imgArea, {
      scale: 5,
      scrollTrigger: {
        trigger: modelInner,
        start: 'top top',
        endTrigger: jsSecSlide,
        end: body,
        // end: "top+=2000 top",
        end: "bottom bottom",
        scrub: 2,
        pin: modelInner,
        pinSpacing: false,
        // markers: true,
      }
    });

    // ---------main画像のズーム----------
    gsap.to(mainImg, {
      width: '100vw',
      height: '100vh',
      scrollTrigger: {
        trigger: modelInner,
        start: 'top top',
        endTrigger: jsSecSlide,
        // end: "top+=1000 top",
        end: "top top",
        scrub: 2,
        // pin: mainImg,
        // markers: true,
      }
    });

    // ---------main画像のズームアウト----------
    gsap.to('#jsSecIntro .js-main', {
      scale: 1,
      scrollTrigger: {
        trigger: modelInner,
        start: 'top top',
        endTrigger: jsSecSlide,
        end: "top top",
        // end: "top+=1000 top",
        scrub: 2,
        // markers: true,
      }
    });

    // ---------main画像のcover----------

    ScrollTrigger.create({
      trigger: jsSecSlide,
      start: 'top top',
      // start: 'top-=1000 bottom',
      onEnter: () => {
        mainCover.classList.add('act')
      },
      onLeaveBack: () => {
        mainCover.classList.remove('act')
      },
      // markers: true,
    });


  }

})();
export default conceptScrollImg;